import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Container } from "./styles";
import { LightTooltip } from "../../../reusable-components/CustomTooltip/CustomTooltip";

interface Props {
  handleClick?: () => void;
  count: number;
  verified?: boolean;
  processed?: boolean;
  size?: SizeProp;
  documentsNames?: string[];
}

const ButtonWithBadge = ({ handleClick, count, verified, processed, size, documentsNames }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <LightTooltip
        title={
          <Container>
            <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
              {t(`components.documents_badge.${processed ? "processed" : verified ? "verified" : "needs_attention"}`)}
            </span>

            {documentsNames && (
              <div>
                <span style={{ fontWeight: "bold" }}>Documents:</span>
                <ul>
                  {documentsNames?.map((documentName, idx) => {
                    return !!documentName && <li key={idx}>{documentName}</li>;
                  })}
                </ul>
              </div>
            )}
          </Container>
        }
      >
        <Button
          variant="text"
          onClick={handleClick}
          style={{ color: "slategray" }}
        >
          <Badge
            color={processed ? "success" : verified ? "primary" : "error"}
            showZero
            badgeContent={count}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            // title={t(
            //   `components.documents_badge.${
            //     processed ? "processed" : verified ? "verified" : "needs_attention"
            //   }`
            // )}
          >
            <FontAwesomeIcon
              icon={faFile}
              size={size}
            />
          </Badge>
        </Button>
      </LightTooltip>
    </>
  );
};

export default ButtonWithBadge;
